'use client';

import { useCallback } from 'react';
import { FacetBreadcrumbsControl } from '../../FacetBreadcrumbs/FacetBreadcrumbsControl';
import { useSearchControllers } from '../headless/SearchDefinitionContext';
import { FacetBreadcrumbsProps } from './FacetBreadcrumbs.types';

export const FacetBreadcrumbs = ({ className }: FacetBreadcrumbsProps) => {
  const controllers = useSearchControllers();
  const { state, methods } = controllers.useBreadcrumbManager();

  const handleDeselectAll = useCallback(() => {
    methods?.deselectAll();
  }, [methods]);

  // A facet deep link server-renders chips, but `createStaticState` JSON-clones
  // the controller state, so each value's `deselect` is stripped and `methods`
  // is undefined until hydration — permanently, when hydrateStaticState fails.
  // The control renders those actions disabled instead of swallowing clicks.
  return (
    <FacetBreadcrumbsControl
      state={state}
      onDeselectAll={handleDeselectAll}
      isReady={methods !== undefined}
      className={className}
    />
  );
};
